import { BasePlaceholder, ConstructorProps } from './base';

import { Group } from 'fabric/fabric-impl';
import SnapToGrid from '../snap-to-grid';
import TeamComposition from './complex/team-composition';
import TeamPeriodFouls from './complex/team-period-fouls';
import { commonPlaceholder } from '../../types/placeholders/create-argument';

export class Complex extends BasePlaceholder {
  private teamComposition: TeamComposition;
  private teamPeriodFouls: TeamPeriodFouls;

  constructor(props: ConstructorProps) {
    super(props);
    this.teamComposition = new TeamComposition({ manager: this.manager });
    this.teamPeriodFouls = new TeamPeriodFouls({ manager: this.manager });
  }

  create(props: commonPlaceholder) {
    let placeholder: Group;

    switch (props.indicator) {
      case 'lastGameResults': {
        placeholder = this.createImagePlaceholder(props);
        SnapToGrid.snapToGrid([placeholder]);
        break;
      }
      case 'teamComposition': {
        placeholder = this.teamComposition.create();
        break;
      }
      case 'teamPeriodFouls': {
        placeholder = this.teamPeriodFouls.create();
        break;
      }
      default: {
        throw new Error('Unknown placeholder type');
      }
    }

    this.canvas.add(placeholder);
    return placeholder;
  }
}
